/**
 * Truncate a deposit address for display, e.g.
 * `0x7854f3…5139F0` (Figma: Transfer Crypto). Keeps the leading + trailing
 * characters with an ellipsis between; short strings are returned unchanged.
 * Kept local (not `@funkit/utils`) so connect-rn doesn't take that dep just for
 * one formatter, and so the lead/trail counts can match the RN design.
 */
export function formatDepositAddress(
  address: string | undefined,
  leading = 6,
  trailing = 6,
): string {
  if (!address) {
    return ''
  }
  if (address.length <= leading + trailing) {
    return address
  }
  return `${address.slice(0, leading)}…${address.slice(-trailing)}`
}
